module.exports = __webpack_public_path__ + "static/media/20_galeria_plantillas_combo_duo_cuad_16.f7ad13b6.png";